import api from '@common/utils/api';
import DispatchConstants from '@common/constants/DispatchConstants';
import User from '@common/models/User';
import { GetUserInterface } from '../types';

const UserActions = {
  getUser({ appName, pageWithSensitiveInformation = false, includeSummary = false, brand }: GetUserInterface): any {
    return (dispatch) =>
      dispatch(
        api.users.getUser({
          appName,
          pageWithSensitiveInformation,
          includeSummary,
          brand,
        }),
      ).then((response: any = {}) => {
        if (response.success && response.response) {
          const userModel = User(response.response);
          dispatch(UserActions.updateUserInfo(userModel));
          // for client auth purposes
          return response.response;
        }
        return response;
      });
  },
  updateUserInfo(data) {
    return (dispatch) =>
      dispatch({
        type: DispatchConstants.UPDATE_USER_INFO,
        payload: data,
      });
  },
};

export default UserActions;
